import styled, { css } from "styled-components";
import Link from "next/link";

import {
  BUTTON_SIZE,
  COLORS,
  FONT_SIZE,
  hoverStyles,
} from "../../constants/Styles";

export const HAMBURGER_SIZE = 940;
export const HAMBURGER_PX = `${HAMBURGER_SIZE}px`;
export const SHRINK_SEARCH_SIZE = 1220;
export const SHRINK_SEARCH_PX = `${SHRINK_SEARCH_SIZE}px`;

export const HEADER_HEIGHT = "6rem";

const linkStyles = css`
  color: ${COLORS.secondaryLight};
  padding: 0 0.25rem;
  display: flex;
  align-items: center;
  cursor: pointer;

  > img {
    margin: 0 0.5rem 0 0;
  }

  ${hoverStyles}
`;

const Header = styled.div`
  display: flex;
  padding: 1rem;
  color: ${COLORS.secondaryLight};
  width: 100vw;
  flex-direction: column;
  gap: 1rem;

  @media print {
    display: none;
    position: static;
  }
`;

const HeaderRow = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: ${HEADER_HEIGHT};
`;

const StyledLink = styled.div`
  margin: 0 1rem 0 2rem;
`;

const Navigation = styled.div`
  align-items: center;
  padding-right: 1rem;
`;

const RightSection = styled.div`
  display: flex;
  margin-left: auto;
  align-items: center;
`;

const LinkContainer = styled.div`
  margin: 1rem 1.5rem;
  font-size: ${FONT_SIZE.size24};
  display: flex;
`;

const MobileLinkComponent = styled.div`
  width: 100%;
  ${linkStyles}
`;

const LinkComponent = styled(Link)`
  text-decoration: none;
  ${linkStyles}
`;

const HamburgerContainer = styled.div`
  border-radius: 50%;
  background-color: ${COLORS.darkGray};
  padding: 0.5rem;
  right: 1.25rem;
  top: 1.25rem;
  overflow: hidden;
  min-width: 4rem;

  .hamburger-react {
    > div {
      // necessary to override the default styling from hamburger-react
      background: ${COLORS.secondary} !important;
    }
  }
`;

const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 6rem;
`;

const OrderingSteps = styled.div`
  display: flex;
  margin: 0 auto;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
`;

const OrderingStep = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;

  > span {
    white-space: nowrap;
  }

  ${({ isSelected }) => isSelected && `color: white`}
`;

const HorizontalLine = styled.div`
  height: 1px;
  width: 1.5rem;
  background-color: ${COLORS.secondaryLight};
`;

const CircleLinkContainer = styled.div<{ isSelected: boolean }>`
  position: relative;
  ${({ isSelected }) =>
    isSelected &&
    `
    > a {
      > div {
        background: linear-gradient(0deg, ${COLORS.secondaryLight} 0%, ${COLORS.secondaryLight} 100%), ${COLORS.inputGray};
      }
    }
  `}
`;

const StepMarker = styled.div<{
  isPrimary: boolean;
}>`
  height: ${BUTTON_SIZE};
  width: ${BUTTON_SIZE};
  border-radius: 50%;
  background-color: ${COLORS.darkGray};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${COLORS.secondaryLight};

  ${({ isPrimary }) =>
    isPrimary &&
    `
    background-color: ${COLORS.primary};
    color: ${COLORS.secondary};
  `}
`;

const ProcessingHeaderIcon = styled.div`
  display: flex;

  animation: rotate 1s infinite linear;

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export {
  Header,
  StyledLink,
  Navigation,
  RightSection,
  HamburgerContainer,
  LinksContainer,
  LinkContainer,
  LinkComponent,
  OrderingStep,
  HorizontalLine,
  OrderingSteps,
  CircleLinkContainer,
  MobileLinkComponent,
  HeaderRow,
  StepMarker,
  ProcessingHeaderIcon,
};
